// extracted by mini-css-extract-plugin
module.exports = {"create-free-accnt":"CreateFreeAccount-module__create-free-accnt___1JuYK","form-container":"CreateFreeAccount-module__form-container___uY_qr"};